import axios from "axios";

export const loadRates = async () => {

    // editable version
    // https://docs.google.com/spreadsheets/d/1gxkKNHeNbFAbLqnwn-Vt2d6K9KkNm5HYJwXCnK5Z8KA/edit#gid=0

    // published version
    // https://docs.google.com/spreadsheets/d/e/2PACX-1vTRFFS_bd9stss1Uh1k8PbEK4zd3iGQPSa8Ogn82gQD6t05DPxcSe4jIfE2pXZTbbig4tcQ_ZyYIn86/pubhtml

    // we aren't doing any clever reading of the spreadsheet here since this
    // takes way too much security and isn't worth the effort
    // let's just read the published html version of the spreadsheet and parse

    const url = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTRFFS_bd9stss1Uh1k8PbEK4zd3iGQPSa8Ogn82gQD6t05DPxcSe4jIfE2pXZTbbig4tcQ_ZyYIn86/pubhtml"
    const response = await axios({ method: 'get', url, responseType: 'text' });
    const html = document.createRange().createContextualFragment(response.data);
    const infoList = Array.from(html.querySelectorAll("td").values()).map(v => v.innerText);

    let perStreamRate = 0,
        digitalTrackPrice = 0,
        digitalAlbumPrice = 0,
        vinylAlbumPrice = 0,
        cdAlbumPrice = 0;

    for (let i = 0; i < infoList.length; i++) {
        const s = infoList[i];
        if (s === "Per Stream Rate") perStreamRate = +infoList[i + 1]
        if (s === "Digital Track Price") digitalTrackPrice = +infoList[i + 1]
        if (s === "Digital Album Price") digitalAlbumPrice = +infoList[i + 1]
        if (s === "Vinyl Album Price") vinylAlbumPrice = +infoList[i + 1]
        if (s === "CD Album Price") cdAlbumPrice = +infoList[i + 1]
    }

    return {
        perStreamRate,
        digitalTrackPrice,
        digitalAlbumPrice,
        vinylAlbumPrice,
        cdAlbumPrice,
    }


}